import { useContext, useEffect } from 'react'

import { ModalActionContext, ModalActionsElement } from './ModalActionContext'
/**
 * Use this hook to override the actions of a modal.
 * @param actions - The actions to override the modal with.
 * @example
 * ```tsx
 *   useModalActionsOverride(
 *     <ModalActionHeader>
 *       <ModalCloseAction
 *         onClose={() => {
 *           // perform your close action
 *         }}
 *       />
 *       <ModalBackAction
 *         onBack={() => {
 *           // perform your back action
 *         }}
 *       />
 *     </ModalActionHeader>
 *   )
 * ```
 */
export const useModalActionsOverride = (actions: ModalActionsElement) => {
  const { setModalActions } = useContext(ModalActionContext)
  useEffect(() => {
    setModalActions(actions)
  }, [actions, setModalActions])

  useEffect(() => {
    return () => {
      // Clean up modal actions in a separate useEffect, so that it only runs on unmount
      setModalActions(undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
